import ReportPrepaidList from './report-prepaid.list';

export default {
  list: ReportPrepaidList,
};
